module.exports = __webpack_public_path__ + "media/coins-drop.5bb2394c.mp3";